module.exports = __webpack_public_path__ + "static/media/huRules.411bf4b1.png";